import React from 'react';
import {
    POLICY_SCHEDULE,
    DO_NOT_DISPLAY_POLICY_SCHEDULE_TAB_POLICY_STATUSES,
    DO_NOT_DISPLAY_FINANCIALS_TAB_POLICY_STATUSES,
    TAB_FINANCIALS,
    POLICY_STATUS_MN_DRAFT,
    POLICY_STATUS_MN_REFERRED,
    REJECTED_OR_DECLINED_STATUSES,
} from '../../helpers/constants';
import { isGatewayPlutusLawsys } from '../../helpers/functions';
import { NavigationBar } from 'arag-ui-lib';
import CONTENT_STRINGS from '../../helpers/contentStrings';

const PolicyTabs = (props) => {
    const { Store, User, SelectActiveTab, SelectedApp, isArag, isSolicitor, advanceDisbursementsEnabled } = props;
    const { policyStatusMachineName, systemsOfRecordId } = SelectedApp;

    // Financials tab only exists for gATEway-PLUTUS-Lawsys policies, and only for ARAG users (AC12) -
    // Solicitors/Brokers never see it. The API endpoint itself is also role-restricted server-side
    // (ApplicationsController.Financials), so this hide is a UX convenience, not the only enforcement.
    const showFinancials = isGatewayPlutusLawsys(systemsOfRecordId) && isArag;

    const showAdvancedDisbursements = advanceDisbursementsEnabled
        && (User.loggedInUser.solicitorGroupAllowedToApplyForDisbursements || isArag)
        && policyStatusMachineName !== POLICY_STATUS_MN_DRAFT
        && policyStatusMachineName !== POLICY_STATUS_MN_REFERRED;

    const navItems = [
        { key: 'application', label: CONTENT_STRINGS.APPLICATION, navItemTestId: `policy-details-application-tab` },
        { key: 'overview', label: CONTENT_STRINGS.OVERVIEW, navItemTestId: `policy-details-overview-tab` },
        {
            key: 'documents',
            label: CONTENT_STRINGS.DOCUMENTS,
            disabled: policyStatusMachineName === POLICY_STATUS_MN_DRAFT && isSolicitor,
            navItemTestId: `policy-details-documents-tab`
        },
        {
            key: 'update',
            label: CONTENT_STRINGS.UPDATE,
            disabled: policyStatusMachineName === POLICY_STATUS_MN_DRAFT || policyStatusMachineName === POLICY_STATUS_MN_REFERRED,
            navItemTestId: `policy-details-update-tab`
        },
        {
            key: 'policySchedule',
            label: `${CONTENT_STRINGS.POLICY} ${POLICY_SCHEDULE}`,
            disabled: DO_NOT_DISPLAY_POLICY_SCHEDULE_TAB_POLICY_STATUSES.includes(policyStatusMachineName),
            navItemTestId: `policy-details-policy-schedule-tab`
        },
        showFinancials
            ? {
                key: TAB_FINANCIALS,
                label: CONTENT_STRINGS.FINANCIALS,
                disabled: DO_NOT_DISPLAY_FINANCIALS_TAB_POLICY_STATUSES.includes(policyStatusMachineName),
                navItemTestId: `policy-details-financials-tab`
            }
            : null,
        showAdvancedDisbursements
            ? { key: 'advancedDisbursements', label: CONTENT_STRINGS.ADVANCE_DISBURSEMENTS, navItemTestId: `policy-details-advanced-disbursements-tab` }
            : null,
        {
            key: 'pendingChanges',
            label: CONTENT_STRINGS.PENDING_CHANGES,
            disabled: policyStatusMachineName === POLICY_STATUS_MN_DRAFT || REJECTED_OR_DECLINED_STATUSES.includes(policyStatusMachineName),
            navItemTestId: `policy-details-pending-changes-tab`
        },
    ].filter(Boolean);

    const handleNavItemSelect = (key) => {
        const item = navItems.find(n => n.key === key);
        if (item && !item.disabled) {
            SelectActiveTab(key);
        }
    };

    return (
        <div className="noprintarea">
            <NavigationBar
                id={"policy_tabs"}
                navItems={navItems}
                activeItemKey={Store.activeTab}
                onNavItemSelect={handleNavItemSelect}
            />
        </div>
    );
};

export default PolicyTabs;
